import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Button,
  message,
  Skeleton,
  Divider,
} from "antd";
import ConsultationInputs from "../inputs/consultation";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteCoreProduct from "@general/deleteCoreProduct";
import moment from "moment-jalaali";

const UPDATECONSULTATION = gql`
  mutation updateConsultation(
    $updateConsultationInput: UpdateConsultationInput!
    $id: ID!
  ) {
    updateConsultation(
      updateConsultationInput: $updateConsultationInput
      id: $id
    )
  }
`;

const GETPRODUCT = gql`
  query ($id: ID!) {
    getProduct(id: $id) {
      createdAt
      updatedAt
      name
      description
      strikethroughRial
      amountRial
      image
    }
  }
`;

function ConsultationDetails({ id, onDataUpdate }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [initialData, setInitialData] = useState({});

  const [runUpdateConsultation, updateConsultation] = useMutation(
    UPDATECONSULTATION,
    {
      onCompleted() {
        message.success("خدمت بروزرسانی شد.");
        onDataUpdate();
      },
      onError(err) {
        console.log("خطا: " + err.message);
        message.error("مشکلی پیش آمده! خدمت بروزرسانی نشد.");
      },
    }
  );

  const doUpdateData = (updateConsultationInput) => {
    runUpdateConsultation({
      variables: {
        id,
        updateConsultationInput,
      },
    });
  };
  const [getServiceData, serviceData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct }) {
      const {
        createdAt,
        updatedAt,
        name,
        description,
        strikethroughRial,
        amountRial,
        image,
      } = getProduct;
      const serviceData = {
        name,
        description,
        strikethroughRial,
        amountRial,
        image,
      };
      form.setFieldsValue(serviceData);
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
      });
    },
  });
  useEffect(() => {
    if (id) {
      getServiceData({
        variables: {
          id,
        },
      });
    }
    setEditable(false);
  }, [id]);
  const { createdAt, updatedAt } = initialData;
  if (serviceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <div>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>
      <Form
        layout="vertical"
        onFinish={doUpdateData}
        form={form}
        disabled={!editable}
      >
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <ConsultationInputs error={error} />
          </Col>
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateConsultation.loading && true}
          >
            بروزرسانی
          </Button>
          <DeleteCoreProduct
            id={id}
            onDeleteCoreProduct={onDataUpdate}
            error={error}
          >
            <Button danger>حذف</Button>
          </DeleteCoreProduct>
        </Space>
      </Form>
    </div>
  );
}

export default ConsultationDetails;
